module.exports = __webpack_public_path__ + "static/media/angela-lesb.3edc8084.jpg";